import { render, staticRenderFns } from "./herocomment.vue?vue&type=template&id=05bf57fc&"
import script from "./herocomment.vue?vue&type=script&lang=js&"
export * from "./herocomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports